/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Start',
	homePageTabsLabel: 'Hjemmeindhold',
	myContent: 'Mit indhold',
	teamContent: 'Teamindhold',
	folder: 'Folder',
	files: 'Filer',
	actionMenu: 'Handlingsmenu',
	myFolder: 'Mine foldere',

	emptyFolderNoContent: 'Intet indhold',

	//EmptyStates
	emptyRecentTitle: 'Du har ikke fået vist noget indhold for nylig.',
	emptyStateTitle: 'Start med at tilføje data',
	emptyStateBody: 'Klik på Upload data ovenfor, eller træk og placér for at uploade data.',
	emptySearchResultTitle: 'Søgningen returnerede ingen resultater.',
	emptyPortalTitle: 'Ingen portaler',
	emptyPortalBody: 'Du har ingen portaler i øjeblikket.',
	emptyWsProjectTitle: 'Start med at oprette en notesbog i Watson Studio.',
	emptyWsProjectBody: 'Når du vender tilbage til Cognos Analytics, er din notesbog her.',
	emptyFilteredResultTitle: 'De anvendte filtre returnerede ingen resultater.',
	emptyDialogViewTitle: 'Ingen elementer',
	removeFromRecents: 'Fjern fra seneste',

	// Welcome Banner
	welcomeBannerGreeting: 'Velkommen til Cognos Analytics with Watson.',
	welcomeBannerDescription: 'Cognos Analytics with Watson stiller AI-dreven selvbetjeningsanalyse til rådighed for brugere. Se, hvordan automatiseret dataklargøring, dataopsporing og visualiseringer kan fremme mere sikre beslutninger.',
	welcomeBannerDescription_trialUser: 'Kom i gang med det samme ved at se vores introduktionsvideo, produktrundtur og Kom godt i gang-skilleblad.',
	takeTourButtonLabel: 'Tag en rundtur',
	watchVideoButtonLabel: 'Se video',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Er du sikker på, at du vil deaktivere velkomstbanneret fra din startside? Du kan når som helst aktivere dette igen under Profil og indstillinger > Indstillinger > Generelt. ',
	hideWelcomeBannerTitle: 'Deaktivér velkomstbanner',
	ok: 'OK',
	cancel: 'Annullér',
	warn: 'Advarsel',
	//howto video dialog
	modal_how_title: 'Se oversigt over Cognos Analytics',
	modal_overview_title: 'Se oversigt over Cognos Analytics',
	modal_how_play: 'Afspil video',
	modal_how_video_title_overview: 'Oversigt',
	modal_how_video_title_getStarted: 'Kom godt i gang med 11.2',
	modal_how_video_title_newUI: 'Velkommen til det nye Cognos',
	modal_how_video_title_dataModule: 'Datamoduler - oversigt',
	modal_how_video_title_explore: 'Dataudforskning - oversigt',
	modal_how_video_title_dashboard: 'Interaktive dashboards - oversigt',
	modal_how_video_title_reporting: 'Rapportering - oversigt',
	modal_how_video_title_mobile: 'Du har Cognos lige ved hånden',

	// Toolbar
	search: 'Søg',
	addFolder: 'Tilføj folder',
	addLink: 'Tilføj link',
	filter: 'Filtrér',
	sort: 'Sortér',
	settings: 'Indstillinger',
	tilesView: 'Flisevisning',
	listView: 'Listeoversigt',
	columnView: 'Kolonnevisning',
	backToSearch: 'Tilbage til søgeresultater',

	// Toolbar Actions
	sortBy: 'Sortér efter',
	sortOrder: 'Sortér',
	name: 'Navn',
	modifiedTime: 'Ændret',
	type: 'Type',
	ascending: 'Stigende',
	descending: 'Faldende',
	resetSort: 'Nulstil sortering',

	filterType: 'Type',
	filterModificationTime: 'Ændret',
	all: 'Alle',
	today: 'I dag',
	yesterday: 'I går',
	pastWeek: 'Sidste uge',
	pastMonth: 'Sidste måned',
	resetFilters: 'Nulstil filtre',
	resultLimit: 'Resultatgrænse',

	filterSearchPlaceHolder: 'Filtrér efter nøgleord',

	resetFilterTag: 'Klik på X for at nulstille filtre.',
	filterTagToolTip: 'Filtre anvendt: %{appliedFilters}.',

	folderName: 'Foldernavn',
	addAFolder: 'Tilføj en folder',
	add: 'Tilføj',
	error: 'Fejl',
	newFolderDefaultName: 'Ny folder',
	toastCreateNewFolder: 'Folderen %{nameOfFolder} blev oprettet i %{tabName}.',
	folderAdded: 'Folder er tilføjet',
	refresh: 'Opfrisk',
	openFolder: 'Åbn folder',

	addAUrl: 'Tilføj en URL',
	linkName: 'URL-navn',
	linkNamePlaceholder: 'Tilføj URL-navn',
	linkDescription: 'Beskrivelse (valgfri)',
	linkDescriptionPlaceholder: 'Tilføj en beskrivelse',
	linkUri: 'URL',
	linkUriPlaceholder: 'Tilføj en URL med et acceptabelt domæne',
	acceptableDomains: 'Acceptable domæner',
	viewAcceptableDomains: 'Vis acceptable domæner',
	mandatoryField: 'Obligatorisk felt',
	linkAdded: 'URL tilføjet',
	toastCreateNewLink: '%{nameOfLink} blev tilføjet til %{tabName}.',
	noEntries: 'Der er ingen indgange i listen over acceptable domæner. Kontakt administratoren.',
	unacceptableDomain: 'Din URL anvender et ugyldigt domæne. Klik på \'Vis acceptable domæner\' for at få vist en liste over domæner, du kan bruge.',

	compact: 'Komprimeret',
	short: 'Kort',
	default: 'Standard',
	rowSize: 'Rækkestørrelse',

	// GroupyByTypes
	folders: 'Foldere',
	reports: 'Rapporter',
	dashboards: 'Dashboards',
	data: 'Data',
	packages: 'Pakker',
	explorations: 'Udforskninger',
	stories: 'Historier',
	notebooks: 'Notesbøger',
	others: 'Andet',

	// Error Messages
	itemsOverLimit: 'Det angivne navn "%{itemName}" er længere end grænsen på 20 tegn. Angiv et andet navn for at fortsætte.',
	errorMessageLengthFolderName: 'Angiv et foldernavn på maksimalt 255 tegn.',
	errorMessageLengthLinkName: 'Angiv et linknavn på maksimalt 255 tegn.',
	toastLaunchPerspectiveError: 'Kan ikke åbne %{objectType}.',
	errorNoAccessTitle: 'Du har ikke adgang til dette indhold',
	errorNoAccessBody: 'Kontakt administratoren, eller se følgende link:',
	errorEnableExternalContent: 'Aktivering af eksternt indhold',

	//TableHeader
	lastAccessed: 'Sidst åbnet',
	location: 'Placering',
	tenant: 'Lejer',

	// GetStartedTab
	getStartedLabel: 'Kom godt i gang med IBM Cognos Analytics',
	learningHowToLabel: 'Læringsressourcer',
	learningHowToDescription: 'Forøg din viden og få hjælp ved at oprette forbindelse til fællesskabet, læse dokumentation og se videoer.',
	learningHowToActionLabel: 'Start læringsdelvinduet',
	howToVideosLabel: 'Sådan gør du-videoer',
	howToVideosDescription: 'Få mere at vide om, hvordan du bruger IBM Cognos Analytics, og få mere udbytte af dine data.',
	howToVideosActionLabel: 'Se videoer',
	acceleratorCatalogLabel: 'Accelerator-katalog',
	acceleratorCatalogDescription: 'Gennemse et voksende katalog over anvendelse inden for brancher, guider, tilpassede visualiseringer og meget mere.',
	acceleratorCatalogActionLabel: 'Gennemse katalog',
	sampleSectionTitle: 'Eksempler',
	sampleSectionDescription: 'Eksperimentér med eksempler, der viser de mange muligheder i Cognos Analytics.',
	// Samples Section
	createDashboardSampleTitle: 'Sådan opretter du dit første dashboard',
	createDashboardSampleDescription: 'Begynd din rejse ud i analyser med Cognos Dashboards.',
	nlaSampleTitle: 'Eksempelrapport',
	nlaSampleDescription: 'Brug dette eksempel på en analyse af et loyalitetsprograms medlemsaktivitet ved årets afslutning til at udforske, hvad der er muligt med Cognos Analytics Reports.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Udvid visualiseringsbiblioteket med tilpassede visualiseringer som f.eks. Sankey-diagrammet.',
	viewAllSamplesActionLabel: 'Vis alle eksempler',
	byFeatureTitle: 'Efter funktion',
	byFeatureDescription: 'Gennemse eksempler efter funktion, f.eks. kernefunktionalitet, tilpassede styringselementer, udvidelser, notesbøger og relative datoer.',
	byIndustryTitle: 'Efter branche',
	byIndustryDescription: 'Gennemse eksempler efter branche, f.eks. automobil, bankvirksomhed etc. ',
	// SamplesTab
	sampleTabTitle: 'Få inspiration fra de allerede byggede eksempler',
	sampleTabLabel: 'Se i Accelerator-kataloget for at vist flere eksempler og udvidelser fra IBM, partnere og kunder',

	// quickLaunch
	quickLaunchLabel: 'Hurtig start',
	expand: 'Udvid',
	collapse: 'Skjul',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Begynd med at vælge det, du vil oprette.',

	// contentPageView
	contentPageTitleLabel: 'Indhold',
	uploadFile: 'Upload data',
	new: 'Ny',
	create: 'Opret',
	more: 'Mere',

	// open dialog
	selectDataSourcesToAdd: 'Vælg datakilder, der skal tilføjes.',
	openDialogDefaultTitle: 'Åbn',

	// save dialog
	save: 'Gem',
	saveAs: 'Gem som',
	saving: 'Gemmer...',
	selectedDestination: 'Valgt destination: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' findes allerede med en anden type. Vælg et andet navn.',
	confirmOverwriteTitle: 'Bekræft erstatning af eksisterende data',
	confirmOverwriteMsg: 'Filen \'%{nameOfFile}\' findes allerede. Vil du erstatte dens data med dataene i den valgte fil?',

	// copy move dialog
	copy: 'Kopiér',
	move: 'Flyt',
	copyOrMove: 'Kopiér eller flyt: ',
	copyOnly: 'Kopiér ',
	createShortcut: 'Opret genvej',
	createShortcutDialogTitle: 'Opret genvej: ',

	// External asset types
	wsProject: 'Watson Studio-projekt',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Pakke',
	dataModule: 'Datamodul',
	exploration: 'Udforskning',
	mode: 'Tilstand',
	live: 'Live',
	snapshot: 'Snapshot',
	noSnapshotsFound: 'Intet snapshot fundet',
	uploadedFile: 'Uploadet fil',
	fileUpload: 'Upload data',
	dataSetEx: 'Datasæt',
	externalRepository: 'Eksternt opbevaringssted',
	queryMode: 'Forespørgselstilstand',
	queryModeCompatible: 'Kompatibel',
	queryModeDynamic: 'Dynamisk',
	report: 'Rapport',
	activeReport: 'Aktiv rapport',
	query: 'Forespørgsel',
	analysis: 'Analyse',
	dashboard: 'Dashboard',
	dashboardTemplate: 'Dashboardskabelon',
	jupyterNotebook: 'Notesbog',
	wsNotebook: 'Watson Studio-notebog',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Historie',
	workspace: 'Arbejdsområde',
	pagelet: 'Side',
	content: 'Indhold',
	directory: 'Navneområder',
	dataSet: 'Datasæt',
	powerPlayCube: 'PowerPlay-kube',
	powerPlayReport: 'PowerPlay-rapport',
	powerPlay8Report: 'PowerPlay-rapport',
	setPowerPlay8ReportOptions: 'Angiv indstillinger for PowerPlay-rapport',
	powerPlay8ReportView: 'PowerPlay-rapportfremvisning',
	reportTemplate: 'Rapportskabelon',
	packageConfigurations: 'Pakkekonfiguration',
	agent: 'Agent',
	agentDefinition: 'Agentdefinition',
	agentDefinitionView: 'Agentfremvisning',
	dataMovementTask: 'Dataflytningsopgave',
	dataMovementTaskAlias: 'Alias for dataflytningsopgave',
	document: 'Dokument',
	DocumentRetention: 'Dokumentegenskaber',
	jobDefinition: 'Jobdefinition',
	job: 'Job',
	jobs: 'Jobs',
	metricsDataSourceETLTask: 'ETL-opgave for metrikdatakilde',
	metricsExportTask: 'Metrikeksportopgave',
	metricsFileImportTask: 'Opgave for import af metrikfil',
	metricsMaintenanceTask: 'Metrikvedligeholdelsesopgave',
	planningTask: 'Planlægningsopgave',
	shortcut: 'Genvej',
	shortcuts: 'Genveje',
	URL: 'URL',
	launchable: 'Kan startes',
	dataSetFolder: 'Folder til datasæt',
	ViewAccessibleLabel: 'Vis %{label}',
	overrideReportOptions: 'Tilsidesæt standardindstillinger for rapport',
	formats: 'Formater',
	saveReport: 'Gem rapporten',
	reportView: 'Rapportfremvisning',
	reportviews: 'Rapportfremvisninger',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel-data',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: 'Rolle',
	namespace: 'Navneområde',
	namespaceFolder: 'Navneområde mappe',
	adminFolder: 'Admin mappe',
	//Details
	details: 'Detaljer',
	open: 'Åbn',
	created: 'Oprettet',
	modified: 'Ændret',
	owner: 'Ejer',
	dataSource: 'Datakilde',
	share: 'Del',
	addToFavorites: 'Tilføj til foretrukne',
	properties: 'Egenskaber',
	detailsEmptyStateBody: 'Vælg et element for at få vist dets detaljer',
	editNameAndDescription: 'Redigér navn og beskrivelse',
	none: 'Ingen',
	setPdfOptions: 'Angiv PDF-indstillinger',
	runOptions: 'Kørselsindstillinger',

	//rename dialog
	nameInvalid: 'Navnet er ugyldigt',
	namePlaceholder: 'Angiv et navn',
	description: 'Beskrivelse',
	descriptionInvalid: 'Beskrivelsen må ikke være længere end 350 tegn.',
	descriptionPlaceholder: 'Angiv en beskrivelse',
	errorMessageApostropheError: 'Angiv et filnavn, der ikke indeholder både tegnene \' og "',
	renameCollisionError: '%{name} findes allerede. Angiv et andet navn.',
	unknownRenameError: 'Fejl under ændring af navn på element. Kontakt administratoren, hvis problemet fortsætter.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Kan ikke åbne den angivne folder.',

	//Upload
	uploadToFolder: "Upload til <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Upload til <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>, og start %{launchAction}",
	quickUpload: "Hurtig upload",
	quickUploadAndLaunch: "Træk og placér filer for at uploade til <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>, og åbn i et af følgende områder.",
	unsupportedFilesSingle: "%{files} blev ikke uploadet, fordi den er ugyldig til Hurtig start.",
	unsupportedFilesMultiple: "Filerne blev ikke uploadet, fordi alle de filer, du vælger, skal være gyldige, for at du kan bruge Hurtig start.",
	unsupportedFilesSingleInvalid: "%{files} er ugyldig.",
	unsupportedFilesMultipleInvalid: "%{files} er ugyldig.",
	supportedFileTypes: "Kun følgende filtyper er tilladt: %{extensions}.",
	uploadDragAndDrop: "Træk og placér",
	uploadDragAndDropMessage: "Træk og placér din fil her for at uploade den til <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Søgekriterier \'%{searchTerm}\' er gemt.',
	searchWasntSaved: 'Søgekriterier \'%{searchTerm}\' blev ikke gemt.',
	searchSuggestions: 'Forslag',
	savedSearch: 'Gemte søgninger',
	searchWasDeleted: 'Søgekriterier \'%{searchTerm}\' blev slettet.',
	searchWasntDeleted: 'Søgekriterier \'%{searchTerm}\' blev ikke slettet.',
	savedBarTitle: 'Søg i Cognos Analytics',
	searchContentPageTitle: 'Søg',
	searchContentPageTitleLabel: 'Viser resultater for \'%{searchTerm}\'',
	showingSearchRsult: 'Viser %{resultCount} elementer',
	saveSearch: 'Gem søgning',
	saveTenSearches: 'Du kan gemme 10 søgninger.',
	deleteASearch: 'Slet én for at gemme en anden.',
	close: 'Luk',
	allContent: 'Alt indhold',
	searchResultIn: 'Søgeresultater i: ',
	//recent view
	recents: 'Seneste',
	noAccessRecent: 'Ingen adgang',
	noAccessRecentMsg: 'Du har ikke adgang til dette aktiv. Det kan være deaktiveret eller slettet, eller dine tilladelser kan være blevet reduceret. Kontrollér status på aktivet og dets forventede kildeplacering. Du kan fjerne aktivet fra dine seneste elementer ved at klikke på OK.',
	noAccessMsg: 'Du har ikke adgang til dette aktiv. Det kan være deaktiveret eller slettet, eller dine tilladelser kan være blevet reduceret.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} elementer valgt',
	itemSelected: '%{nameOfSelection} element valgt',

	//properties
	general: 'Generelt',
	schedule: 'Tidsplan',
	permission: 'Tilladelser',
	capabilities: 'Funktioner',
	propertiesTabsLabel: 'Egenskabsindhold',
	searchPath: 'Søgesti',
	id: 'Id',
	language: 'Sprog',
	setLanguage: 'Angiv sprog',
	entryOptions: 'Indtastningsindstillinger',
	setPackage: 'Angiv pakke eller modul',
	sourcePackage: 'Kildepakke eller datamodul',
	associatedSourceAgent: 'Kildepakke',
	setAssociatedSourceAgent: 'Angiv pakke',
	sourceAgent: 'Kildeagent',
	setSourceAgent: 'Angiv kildeagent',
	setCapabilities: 'Angiv funktioner',
	disableEntry: 'Deaktiver denne indgang',
	hideEntry: 'Skjul denne indgang',
	permissions: 'Tilladelser',
	promptForValues: 'Spørg efter værdier',
	yes: 'Ja',
	no: 'Nej',
	setValues: 'Angiv værdier',
	moreOptions: 'Flere muligheder',
	reportFormat: 'Rapportformat',
	enableAccessibilitySupport: 'Aktivér hjælp til handicappede',
	displayOfRunHistory: 'Visning af kørselshistorik',
	occurrences: 'Forekomster',
	days: 'Dag(e)',
	months: 'Måned(er)',
	displayOfReportOutputVersions: 'Visning af rapportoutputversion',
	defaultDisplayOfPortalAction: 'Standardportalhandling',
	viewMostRecentReport: 'Vis den nyeste rapport',
	runTheReport: 'Kør rapporten',
	openWithReportStudio: 'Åbn med Report Studio',
	rowsPerPageInHtmlReports: 'Rækker pr. side i HTML-rapporter',
	enableSelectionBasedInteractivity: 'Aktivér valgbaseret interaktivitet',
	enableAlertsAboutNewVersions: 'Aktivér varsler om nye versioner',
	enableEnhancedUserFeaturesInSavedOutputVersions: 'Aktivér udvidede brugerfunktioner i gemte outputversioner',
	enableCommentsInSavedOutputVersions: 'Aktivér kommentarer i gemte outputversioner',
	run: 'Kør',
	runWithUsersCredentials: 'Med brugers legitimationsoplysninger',
	runWithOwnerCapabilities: 'Med ejerfunktion',
	runAsOwner: 'Som %{ownerName}',
	actionLabelOn: 'Aktiveret',
	actionLabelOff: 'Deaktiveret',
	openReport: 'Redigér',
	openAnalysis: 'Åbn med Analysis Studio',
	openQuery: 'Åbn med Query Studio',
	openPowerPlay8Report: 'Åbn med PowerPlay Studio',
	openInteractiveReport: 'Redigér',
	read: 'Læs',
	write: 'Skriv',
	execute: 'Udfør',
	setPolicy: 'Angiv politik',
	full: 'Fuld',
	traverse: 'Gennemløb',
	grant: 'Tildel',
	deny: 'Afvis',
	permissionCustom: 'Tilpasset',
	permissionDetailsColumnAccess: 'Adgang',
	permissionDetailsColumnPermission: 'Tilladelse',
	permissionDetailsColumnAction: 'Handling',
	permissionSetAccess: 'Angiv adgang',
	permissionRead: 'Læs',
	permissionRun: 'Kør',
	permissionWrite: 'Skriv',
	permissionFull: 'Fuld',
	unavailable: 'Ikke tilgængelig',
	unkownSource: 'Ukendt, åbn rapporten for at få flere oplysninger',
	tenantSettings: 'Indstillinger for lejer',
	tenantSet: 'Lejer opdateret',
	tenantSetError: 'Fejl under angivelse af lejer',
	tenantClear: 'Lejer ryddet',
	tenantClearError: 'Fejl under rydning af lejer',
	shortcutTo: 'Genvej til',
	sourceReport: 'Kilderapport',
	setSourceReport: 'Angiv kilderapport',
	setSourceLocation: 'Angiv placering af kilden %{itemName}',
	linkPackageOrModule: 'Link %{itemName} til en pakke eller et datamodul',
	linkPackage: 'Link %{itemName} til en pakke',
	externalRepositories: 'Eksterne lagre',
	sizeByte: '%{value} B',
	sizeKiloByte: '%{value} KB',
	sizeMegaByte: '%{value} MB',
	sizeGigaByte: '%{value} GB',
	sizeTeraByte: '%{value} TB',
	sizePetaByte: '%{value} PB',
	refreshedDatetime: 'Tidspunkt for opfriskning',
	size: 'Størrelse',
	tenantsWarningMessage: 'Hvis lejeren til en indgang ændres, bliver også lejeren til de underordnede indgange ændret.',
	confirmClearTenantText: 'Hvis du rydder værdien til \'Ingen\', kan andre lejere eventuelt få adgang til indholdet. Klik på OK for at gøre indgangen offentlig eller på Annullér for at bevare den aktuelle lejer.',
	confirmClearTenant: 'Bekræft rydning af lejer',
	currentValues: 'Aktuelle værdier',
	emptyPromptValues: 'Der er ingen værdier i øjeblikket',
	editValues: 'Redigér værdier',
	clear: 'Ryd',
	source: 'Kilde',
	dataRefreshed: 'Data opfrisket',
	//PDF options
	pdfOptions: 'PDF-indstillinger',
	set: 'Sæt',
	portrait: 'Højformat',
	landscape: 'Tværformat',
	letter: 'Letter-format',
	legal: 'Legal-format',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: 'Retning',
	pageDefination: 'Papirstørrelse',
	openPasswordRequired: 'Kræv kodeord for at kunne åbne rapporten',
	accessPasswordRequired: 'Kræv kodeord for at få adgang til rapporten',
	emptyPassword: 'Kodeord må ikke være tomt',
	password: 'Kodeord',
	enterPassword: 'Angiv kodeord',
	confirmPassword: 'Bekræft kodeord',
	passwordMatchError: 'Kodeordene er ikke ens',
	gateway: 'Gateway',
	pageLayout: 'Sidelayout',
	pageStyle: 'Stilart',
	setUrl: 'Angiv URL',
	numberRows: 'Antal rækker',
	numberColumns: 'Antal kolonner',
	timeToRefresh: 'Tidspunkt for opfriskning',
	lastRefreshedBy: 'Opfrisket af',
	unknown: 'Ukendt',
	unknownUpdateError: 'Elementopdatering er ikke udført. Kontakt administratoren, hvis problemet fortsætter.',
	editQuery: 'Rediger forespørgsel',
	greaterOrEqual: 'Større end eller lig med %{upperboundValue}',
	lessOrEqual: 'Mindre end eller lig med %{lowerboundValue}'
});
